import searchRequest from './searchRequest'
import fieldCond from './fieldCond'
import filterCond from './filterCond'
const facilityTypeDatas = window.SIMPL.facilityTypeDatas;

export default function searchItems(map, isInRange, userAuthorities, keyword, filters, maxCount, panelOffset,viewtype) {

    // filter
    let geoFilter = "";
    if (isInRange) {
        geoFilter = " and geo.intersects(Location, geography'POLYGON((" + getBoundsLatLngString(map, panelOffset) + "))')";
    }

    let types = "";
    types = facilityTypeDatas.map(element => element.type);

    //「対象」（施設種類）
    //viewType=JICE：選択した舗装種類のみを対象とする。
    //未指定（filterに格納されていない）の場合：マスタにある全施設種類が対象
    //指定ありの場合：指定した施設種類が対象
    let typeList = [];
    switch(viewtype){
        case "jice":
            typeList = [...typeList, filters.pavementLength];
            break;
        case "report":
            typeList = [...typeList, "report"];
            break;
        case "trafficregulation":
            typeList = [...typeList, "trafficregulation"];
            break;
        default:
            typeList = filters.type?.length === 0 ? types : filters.type;
            break;
    }
    let typeCond = filterCond('type', typeList);

    //photo/report/trafficregulation（以下、特殊種別）とその他の施設種別が検索対象に存在するか確認
    var isPhoto = typeList.includes("photo");
    var isReport = typeList.includes("report");
    var isTrafficRegulation = typeList.includes("trafficregulation");
    var isOther = typeList.some((item) => item !== "photo" && item !== "report" && item !== "trafficregulation")

    let healthLevelCond = "";
    let officeCond = "";
    let primaryCategoryCond = "";
    //検索対象に特殊種別以外が含まれている場合
    if(isOther){
        healthLevelCond = filterCond('overallHealthLevel', filters.overallHealthLevel); //健全度
        switch(viewtype){
            case "kajima":
                primaryCategoryCond = filterCond('primaryCategory', filters.primaryCategory);   //大分類
                break;
            case "fukui":
                officeCond = filterCond('componentManagerOffice', filters.componentManagerOffice);  //管理事務所
                primaryCategoryCond = filterCond('primaryCategory', filters.primaryCategory);   //分類
                break;
            default:
                officeCond = filterCond('componentManagerOffice', filters.componentManagerOffice);  //管理事務所
                break;
        }
    }

    //【等価演算子】
    //eq: フィールドが定数値と等しい、ne: フィールドが定数値と等しくない
    //【範囲演算子】
    //gt: フィールドが定数値より大きい、lt: フィールドが定数値より小さい
    //ge: フィールドが定数値以上、le: フィールドが定数値以下

    let filmingDateTime = "";
    //検索対象にphotoが含まれている場合
    if(isPhoto){
        if(filters.filmingDateTime_str){
            //指定日以上（以降）
            filmingDateTime = filmingDateTime + `filmingDateTime ge '${filters.filmingDateTime_str.replace(/-/g,"/")} 00:00:00'`;
        }
        if(filmingDateTime !== "") filmingDateTime = filmingDateTime + " and "; //調整
        if(filters.filmingDateTime_end){
            //指定日以下（以前）
            filmingDateTime = filmingDateTime + `filmingDateTime le '${filters.filmingDateTime_end.replace(/-/g,"/")} 23:59:59'`;
        }
        if(filmingDateTime !== "") filmingDateTime = `(${filmingDateTime})and `; //調整
    }

    let reportDate = "";
    let reportStatusCond = "";
    //検索対象にreportが含まれている場合
    if(isReport){

        //通報日
        if(filters.reportDate_str){
            //指定日以上（以降）
            reportDate = reportDate + `reportDate ge '${filters.reportDate_str}'`;
        }
        if(reportDate !== "") reportDate = reportDate + " and "; //調整
        if(filters.reportDate_end){
            //指定日以下（以前）
            reportDate = reportDate + `reportDate le '${filters.reportDate_end}'`;
        }
        if(reportDate !== "") reportDate = `and (${reportDate})`; //調整

        //ステータス
        reportStatusCond = filterCond('reportStatus', filters.reportStatus);
    }

    let applicationDate = "";
    let restrictedDateTime = "";
    let applicationStatusCond = "";
    //検索対象にreportが含まれている場合
    if(isTrafficRegulation){

        //申請日
        if(filters.applicationDate_str){
            //指定日以上（以降）
            applicationDate = applicationDate + `applicationDate ge '${filters.applicationDate_str}'`;
        }
        if(filters.applicationDate_str !== "" && filters.applicationDate_end !== "") applicationDate = applicationDate + " and "; //調整
        if(filters.applicationDate_end){
            //指定日以下（以前）
            applicationDate = applicationDate + `applicationDate le '${filters.applicationDate_end}'`;
        }
        if(applicationDate !== "") applicationDate = `and (${applicationDate})`; //調整

        //ステータス
        applicationStatusCond = filterCond('applicationStatus', filters.applicationStatus);

        //規制期間
        if(filters.restrictedDateTime_str){
            //指定日以上（以降）
            restrictedDateTime = restrictedDateTime + `restrictedEndDateTime ge '${filters.restrictedDateTime_str} 00:00'`;
        }
        if(filters.restrictedDateTime_str !== "" && filters.restrictedDateTime_end !== "") restrictedDateTime = restrictedDateTime + " and "; //調整
        if(filters.restrictedDateTime_end){
            //指定日以下（以前）
            restrictedDateTime = restrictedDateTime + `restrictedStartDateTime le '${filters.restrictedDateTime_end} 23:59'`;
        }
        if(restrictedDateTime !== "") restrictedDateTime = `and (${restrictedDateTime})`; //調整
    }

    let reportCond = "";
    let photoCond ="";
    let trafficRegulationCond ="";
    let otherCond = "";
    let roadBoardCond = "";
    //各種別で無関係のフィルタは無視できるよう、nullを固定で要求しておくこと
    switch(viewtype){
        case "kajima":
            photoCond = `(type eq 'photo' and ${filmingDateTime}overallHealthLevel eq null and primaryCategory eq null)`;
            otherCond = `(type ne 'photo' and filmingDateTime eq null${healthLevelCond}${primaryCategoryCond})`;
            break;
        case "fukui":
            photoCond = `(type eq 'photo' and ${filmingDateTime}overallHealthLevel eq null and componentManagerOffice eq null and primaryCategory eq null)`;
            otherCond = `(type ne 'photo' and filmingDateTime eq null${healthLevelCond}${officeCond}${primaryCategoryCond})`;
            break;
        case "nanto":
            photoCond = `(type eq 'photo' and ${filmingDateTime}overallHealthLevel eq null and componentManagerOffice eq null `
                +`and reportDate eq null and reportStatus eq null and applicationDate eq null and applicationStatus eq null and restrictedStartDateTime eq null and restrictedEndDateTime eq null)`;
            reportCond = `(type eq 'report' ${reportDate}${reportStatusCond} and overallHealthLevel eq null and componentManagerOffice eq null and filmingDateTime eq null `
                +`and applicationDate eq null and applicationStatus eq null and restrictedStartDateTime eq null and restrictedEndDateTime eq null)`;
            trafficRegulationCond = `(type eq 'trafficregulation' ${applicationDate}${applicationStatusCond}${restrictedDateTime}`
                +`and overallHealthLevel eq null and componentManagerOffice eq null and filmingDateTime eq null `
                +`and reportDate eq null and reportStatus eq null)`;
            otherCond = `(type ne 'photo' and type ne 'report' and type ne 'trafficregulation' ${healthLevelCond}${officeCond} `
                +`and filmingDateTime eq null and reportDate eq null and reportStatus eq null and applicationDate eq null and applicationStatus eq null and restrictedStartDateTime eq null and restrictedEndDateTime eq null)`;
            break;
        case "report":
            reportCond = `(type eq 'report' ${reportDate}${reportStatusCond} and overallHealthLevel eq null and componentManagerOffice eq null and filmingDateTime eq null `
                +`and applicationDate eq null and applicationStatus eq null and restrictedStartDateTime eq null and restrictedEndDateTime eq null)`;
            break;
        case "trafficregulation":     
            trafficRegulationCond = `(type eq 'trafficregulation' ${applicationDate}${applicationStatusCond}${restrictedDateTime}`
                +`and overallHealthLevel eq null and componentManagerOffice eq null and filmingDateTime eq null `
                +`and reportDate eq null and reportStatus eq null)`;
            break;
        case "jice":     
            //写真関連は含めない
            roadBoardCond = filterCond('roadBoard', filters.roadBoard);   //上下線
            break;
        default:
            //primaryCategoryの絞り込み含まず
            photoCond = `(type eq 'photo' and ${filmingDateTime}overallHealthLevel eq null and componentManagerOffice eq null)`;
            otherCond = `(type ne 'photo' and filmingDateTime eq null${healthLevelCond}${officeCond})`;
            break;
    }

    //filterの結合
    let filter = `&$filter=isRemoved ne true${geoFilter}${typeCond}`;
    switch(viewtype){
        case "report":
            filter += ` and (`;
            filter += `${reportCond}`;
            filter += `)`;
            break;
        case "trafficregulation": 
        filter += ` and (`;
            filter += `${trafficRegulationCond}`;
            filter += `)`;
            break;
        case "nanto":
            filter += ` and (`;
            filter += `${otherCond}`;
            filter += isPhoto ? ` or ${photoCond}`: "" ;
            filter += isReport ? ` or ${reportCond}` : "";
            filter += isTrafficRegulation ? ` or ${trafficRegulationCond}` : "";
            filter += `)`;
            break;
        case "jice": 
            filter += `${healthLevelCond}${officeCond}${roadBoardCond}`;
            break;
        case "kajima":
        case "fukui":
        default:
            filter += ` and (`;
            filter += `${otherCond}`;
            filter += isPhoto ? ` or ${photoCond}`: "" ;
            filter += `)`;
            break;
    }

    // search
    let authCond = fieldCond('authority', userAuthorities);
    keyword = keyword.replace("#","");  //#は無視+削除
    let search = "&search=" + authCond + encodeURI(keyword);

    //取得フィールドの定義
    let requiredSelect = "id,type,authority,identifier,title,startLat,startLng,PhotoURL,endLat,endLng,ThumbnailURL";
    let photoSelect ="uploadDateTime,tags,filmingDateTime,angle";//写真で使用フィールド
    let reportSelect = "reportDate,reportType,reportCircumstance,reportStatus,comment";//通報で使用フィールド
    let trafficRegulationSelect ="applicationDate,restrictedType,restrictedTypeOther,restrictedPlace,restrictedTimeZone,restrictedStartDateTime,restrictedEndDateTime,restrictedDays,detourRoute,applicationStatus";//通行制限で使用フィールド
    let jiceSelect = "roadBoard,laneCode,startPosition,endPosition,originalDataURL";
    let otherSelect = "Roadtitle,componentManagerOffice,address,overallHealthLevel";
    let select = "&$select=";
    switch(viewtype){
        case "kajima":
        case "fukui":
            //必須、写真、分類or大分類
            select += `${requiredSelect},${otherSelect},${photoSelect},primaryCategory`;
            break;
        case "report":
            //必須、通報
            select += `${requiredSelect},${reportSelect}`;
            break;
        case "trafficregulation": 
            //必須、規制
            select += `${requiredSelect},${trafficRegulationSelect},Roadtitle`;
            break;
        case "nanto":
            //必須、その他、写真、通報、規制
            select += `${requiredSelect},${otherSelect},${photoSelect},${reportSelect},${trafficRegulationSelect}`;
            break;
        case "jice": 
            //必須、その他（一部のみ抜粋）、JICE（舗装）
            select += `${requiredSelect},Roadtitle,componentManagerOffice,overallHealthLevel,${jiceSelect}`;
            break;
        default:
            //全て
            select += `${requiredSelect},${otherSelect},${photoSelect},${reportSelect},${trafficRegulationSelect},primaryCategory`;
            break;
    }

    // top
    let top = "&$top=" + maxCount; //targetTypes.includes('pavement') ? 200 : 100;

    // orderby
    let orderby = "";
    switch(viewtype){
        case "report":
            //通報日の降順
            orderby = "&$orderby=reportDate desc";
            break;
        case "trafficregulation":
            //申請日の降順 
        orderby = "&$orderby=applicationDate desc";
            break;
        default:
            if (keyword === "") {
                // キーワード指定なしの場合、表示範囲の中央に近い順
                let center = map.getCenter();
                orderby = "&$orderby=geo.distance(Location,geography'POINT(" + center.lng() + " " + center.lat() + ")')";
            }
            else {
                // キーワード指定ありの場合、既定の並べ替え（ドキュメントの一致スコア降順）
                orderby = "";
            }
            break;
    }

    let queryUrl = '?api-version=2017-11-11&queryType=full&searchMode=all&$count=true' + filter + select + search + orderby + top

    return searchRequest(queryUrl);
}

function getBoundsLatLngString(map, panelOffset) {
    let eastLng = map.getBounds().getNorthEast().lng();
    let southLat = map.getBounds().getSouthWest().lat();

    let northWest = point2LatLng(panelOffset, map);
    let northLat = northWest.lat();
    let westLng = northWest.lng();

    return westLng + " " + northLat + ","
        + westLng + " " + southLat + ","
        + eastLng + " " + southLat + ","
        + eastLng + " " + northLat + ","
        + westLng + " " + northLat;

}

// function latLng2Point(latLng, map) {
//     var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
//     var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
//     var scale = Math.pow(2, map.getZoom());
//     var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
//     return new window.google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
// }

function point2LatLng(point, map) {
    var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    var worldPoint = new window.google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
    return map.getProjection().fromPointToLatLng(worldPoint);
}

